import React from 'react';
import PropTypes from 'prop-types';

const Forward2Icon = ({ fontSize = 'large', style = {} }) => {
  let size;
  if (fontSize === 'large') {
    size = 36;
  } else if (fontSize === 'medium') {
    size = 20;
  } else {
    size = 16;
  }
  
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      style={style}
    >
      <path d="M12 5V1l5 5-5 5V7c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6h2c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8z"/>
      <text
        x="12"
        y="16"
        textAnchor="middle"
        fontSize="6"
        fontWeight="bold"
        fill="currentColor"
      >
        2
      </text>
    </svg>
  );
};

Forward2Icon.propTypes = {
  fontSize: PropTypes.string,
  style: PropTypes.object
};

export default Forward2Icon;
